import { render, staticRenderFns } from "./Cn-SDS-Powder.vue?vue&type=template&id=608808e4&scoped=true&"
import script from "./Cn-SDS-Powder.vue?vue&type=script&lang=js&"
export * from "./Cn-SDS-Powder.vue?vue&type=script&lang=js&"
import style0 from "./Cn-SDS-Powder.vue?vue&type=style&index=0&id=608808e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608808e4",
  null
  
)

export default component.exports